module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tat-dashboard-container"
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard d-flex justify-content-between align-items-center",
    staticStyle: {
      "border-radius": "5px !important",
      "padding": "5px 15px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    staticClass: "m-0"
  }, [_vm._v("FF Export Billing Report")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-button', {
    staticClass: "mr-2 text-primary font-weight-bold",
    attrs: {
      "variant": "light",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter mr-1"
  }), _vm._v(" FILTERS\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2 font-weight-bold",
    attrs: {
      "size": "sm",
      "variant": "success",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.exportTallyBillingExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o mr-1"
  }), _vm._v(" TALLY BILLING EXCEL\n          ")]), _vm._v(" "), (_vm.reportData.length > 0) ? _c('b-button', {
    staticClass: "font-weight-bold",
    attrs: {
      "size": "sm",
      "variant": "warning",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o mr-1"
  }), _vm._v(" EXPORT AS EXCEL\n          ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse-filter"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-card', {
    staticClass: "mt-2"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientFilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchReport(1)
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date Range (Job Date)")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "locale-data": _vm.locale,
      "opens": "left"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function(picker) {
        return _c('div', {}, [_vm._v("\n                    " + _vm._s(_vm._f("moment")(_vm.dateRange.startDate)) + " -\n                    " + _vm._s(_vm._f("moment")(_vm.dateRange.endDate)) + "\n                  ")])
      }
    }]),
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Booking NO")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": "Search Booking No"
    },
    model: {
      value: (_vm.Filter.booking_number),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "booking_number", $$v)
      },
      expression: "Filter.booking_number"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": "Search Container No"
    },
    model: {
      value: (_vm.Filter.container_number),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "container_number", $$v)
      },
      expression: "Filter.container_number"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("MBL No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": "Search MBL No"
    },
    model: {
      value: (_vm.Filter.MblNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "MblNoFilter", $$v)
      },
      expression: "Filter.MblNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("HBL No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": "Search HBL No"
    },
    model: {
      value: (_vm.Filter.HblNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "HblNoFilter", $$v)
      },
      expression: "Filter.HblNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Job No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": "Search Job No"
    },
    model: {
      value: (_vm.Filter.assignmentFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "assignmentFilter", $$v)
      },
      expression: "Filter.assignmentFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Months/Year")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.dateStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Duration"
    },
    model: {
      value: (_vm.Filter.dateStatusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateStatusFilter", $$v)
      },
      expression: "Filter.dateStatusFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Billing Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.BillingStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Billing Status"
    },
    model: {
      value: (_vm.Filter.isFinalBillingStatus),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "isFinalBillingStatus", $$v)
      },
      expression: "Filter.isFinalBillingStatus"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Invoice Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.invoiceStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Invoice Status"
    },
    model: {
      value: (_vm.Filter.billingFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "billingFilter", $$v)
      },
      expression: "Filter.billingFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Sob Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.SOBStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select SOB Status"
    },
    model: {
      value: (_vm.Filter.SOBFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "SOBFilter", $$v)
      },
      expression: "Filter.SOBFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Prealert Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PrealertStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Prealert Status"
    },
    model: {
      value: (_vm.Filter.PrealertFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PrealertFilter", $$v)
      },
      expression: "Filter.PrealertFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Branch"
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Line Inv Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.lineInvoiceStatus,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Line Inv Status"
    },
    model: {
      value: (_vm.Filter.line_inv_statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "line_inv_statusFilter", $$v)
      },
      expression: "Filter.line_inv_statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("BL Release Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.mblInvoiceStatus,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select BL Release Status"
    },
    model: {
      value: (_vm.Filter.liner_bl_release_statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "liner_bl_release_statusFilter", $$v)
      },
      expression: "Filter.liner_bl_release_statusFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.Filter.filterBlanks),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "filterBlanks", $$v)
      },
      expression: "Filter.filterBlanks"
    }
  }, [_vm._v("\n                  Filter Blanks (Missing Milestones)\n                ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.Filter.highAlertOnly),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "highAlertOnly", $$v)
      },
      expression: "Filter.highAlertOnly"
    }
  }, [_vm._v("\n                  High Alert Only (>5 days from SOB)\n                ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Alert Days (>X)"
    },
    model: {
      value: (_vm.Filter.highAlertDays),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "highAlertDays", $$v)
      },
      expression: "Filter.highAlertDays"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Quick Search: Job No / MBL / Client"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.fetchReport(1)
      }
    },
    model: {
      value: (_vm.Filter.search),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "search", $$v)
      },
      expression: "Filter.search"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 text-center"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.fetchReport(1)
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', {
    staticClass: "text-muted pull-right"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive mt-2"
  }, [_c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.reportData,
      "fields": _vm.fields,
      "per-page": _vm.pageSize,
      "hover": "",
      "bordered": "",
      "small": "",
      "busy": _vm.isLoading
    },
    scopedSlots: _vm._u([{
      key: "jobDet",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('div', {
          staticClass: "font-weight-bold",
          class: data.item.HighAlert ? 'text-danger' : ''
        }, [_vm._v("\n                " + _vm._s(data.item.JobNo) + "\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "mt-1"
        }, [_c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.JobDate))]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-info ml-1"
        }, [_vm._v(_vm._s(data.item.JobType))])]), _vm._v(" "), _c('div', {
          staticClass: "mt-1 small text-muted"
        }, [_vm._v("\n                " + _vm._s(data.item.Mode) + " | " + _vm._s(data.item.TransportType) + "\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "mt-1 small"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("From:")]), _vm._v(" " + _vm._s(data.item.RaisedFrom) + "\n                "), _c('span', {
          staticClass: "text-muted ml-1"
        }, [_vm._v("By:")]), _vm._v(" " + _vm._s(data.item.RaisedBy) + "\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "mt-1 small font-weight-bold"
        }, [_vm._v("\n                " + _vm._s(data.item.Vessel) + " | " + _vm._s(data.item.Voyage) + "\n              ")])]) : _vm._e(), _vm._v(" "), (data.item) ? _c('div', {
          staticClass: "d-flex flex-column small",
          style: (data.item.TallyPendingHighlight ? 'background-color: #fff3cd; padding: 2px; border-radius: 4px;' : '')
        }, [_c('div', {
          staticClass: "font-weight-bold text-success"
        }, [_vm._v("Inv: " + _vm._s(data.item.TallyInvoiceNo || 'N/A'))]), _vm._v(" "), (data.item.TallyPendingHighlight) ? _c('div', {
          staticClass: "text-danger font-weight-bold small"
        }, [_vm._v("PENDING FROM TALLY")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("Date: " + _vm._s(data.item.TallyInvoiceDate || 'N/A'))]), _vm._v(" "), (data.item.RInvNo !== 'N/A') ? _c('div', {
          staticClass: "mt-1"
        }, [_c('div', {
          staticClass: "text-muted"
        }, [_vm._v("Rev: " + _vm._s(data.item.RInvNo))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted"
        }, [_vm._v("RevDate: " + _vm._s(data.item.ReverseTallyInvDate))])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "mt-1 text-info font-weight-bold"
        }, [_vm._v("\n                " + _vm._s(data.item.TallyBillingClosedStatus) + "\n              ")]), _vm._v(" "), (data.item.ExecutionInvoices) ? _c('div', {
          staticClass: "mt-1 small"
        }, [_c('strong', [_vm._v("Ex.Inv:")]), _vm._v(" " + _vm._s(_vm.truncateText(data.item.ExecutionInvoices, 30)) + "\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(data.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), (data.item.JobId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + data.item.JobNo,
            "PMC_JOBID": data.item.JobId,
            "PMC_JOBNO": data.item.JobNo,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": data.item.JobId,
            "jb_series": data.item.JobNo
          }
        }), _vm._v(" "), (data.item.JobId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + data.item.JobNo,
            "PMC_JOBID": data.item.JobId,
            "PMC_JOBNO": data.item.JobNo,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (data.item.JobId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "JobId": Number(data.item.JobId),
            "JobNo": data.item.JobNo
          }
        }) : _vm._e(), _vm._v(" "), (data.item.JobId) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' + data.item.JobNo,
            "PMC_JOBID": data.item.JobId,
            "PMC_JOBNO": data.item.JobNo,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (data.item.JobId) ? _c('WebhookLogSummary', {
          attrs: {
            "show-trigger-button": true,
            "PMC_title": 'Webhook Log',
            "PMC_JOBID": data.item.JobId,
            "PMC_JOBNO": data.item.JobNo,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (data.item.JobId) ? _c('AssignmentSplitMergeSummary', {
          attrs: {
            "PMC_title": 'Assignment Split/Merge/Move Summary',
            "PMC_JOBID": data.item.JobId,
            "PMC_JOBNO": data.item.JobNo,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('BookingTrack', {
          attrs: {
            "containerArr": data.item.FreightContainers,
            "slineName": data.item.ShippingLine,
            "clientName": data.item.ClientName,
            "modal_title": ("Container Movement Booking No: " + (data.item.BookingNo) + " Job No - " + (data.item.JobNo) + " Client: " + (data.item.ClientName)),
            "JOBNO": data.item.JobNo,
            "shipment_id": Number(0),
            "subscription_id": Number(0),
            "fk_sub_track_id": Number(0),
            "fk_all_module_id": Number(data.item.JobId),
            "fk_booking_id": Number(data.item.fk_booking_id),
            "fk_container_id": Number(0),
            "booking_number": data.item.BookingNo,
            "container_number": ''
          }
        })]
      }
    }, {
      key: "clientDet",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(_vm.truncateText(data.item.ClientName, 25)))]), _vm._v(" "), _c('div', {
          staticClass: "mt-1 small text-muted"
        }, [_vm._v("Line: " + _vm._s(_vm.truncateText(data.item.ShippingLine, 20)))]), _vm._v(" "), _c('div', {
          staticClass: "mt-1 small font-weight-bold"
        }, [_vm._v("B.No: " + _vm._s(data.item.BookingNo || 'N/A'))]), _vm._v(" "), _c('div', {
          staticClass: "mt-1 small text-muted"
        }, [_vm._v("BRF: " + _vm._s(data.item.BrfNo || 'N/A'))]), _vm._v(" "), _c('div', {
          staticClass: "mt-1 small text-muted"
        }, [_vm._v("Enq: " + _vm._s(data.item.EnqBrfNo || 'N/A'))])]) : _vm._e()]
      }
    }, {
      key: "locDet",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('div', {
          staticClass: "d-flex flex-column align-items-start"
        }, [_c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "badge badge-light mb-1",
          attrs: {
            "title": data.item.Por
          }
        }, [_vm._v(_vm._s(_vm.getPortCode(data.item.Por)))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "badge badge-light mb-1",
          attrs: {
            "title": data.item.Pol
          }
        }, [_vm._v(_vm._s(_vm.getPortCode(data.item.Pol)))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "badge badge-light",
          attrs: {
            "title": data.item.Pod
          }
        }, [_vm._v(_vm._s(_vm.getPortCode(data.item.Pod)))])]), _vm._v(" "), _c('div', {
          staticClass: "mt-1 small text-muted"
        }, [_vm._v("FPOD: " + _vm._s(_vm.getPortCode(data.item.Fpod)))])]) : _vm._e()]
      }
    }, {
      key: "billDetails",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column small"
        }, [_c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Type:")]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-info"
        }, [_vm._v(_vm._s(data.item.billingType))])]), _vm._v(" "), _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Sent:")]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.SentToAccountsDate || 'N/A'))])]), _vm._v(" "), _c('div', {
          staticClass: "mt-1 small"
        }, [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("OF Pay:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.OfFirstPaymentDate || 'N/A'))])]), _vm._v(" "), _c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Line Pay:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.oe_sline_inv_pay_date || 'N/A'))])])]), _vm._v(" "), _c('hr', {
          staticClass: "my-1"
        }), _vm._v(" "), _c('div', {
          staticClass: "font-weight-bold mb-1"
        }, [_vm._v("Financials:")]), _vm._v(" "), _c('div', {
          staticClass: "d-flex justify-content-between text-danger"
        }, [_c('span', [_vm._v("Expense:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.Expense || 0))])]), _vm._v(" "), _c('div', {
          staticClass: "d-flex justify-content-between text-success"
        }, [_c('span', [_vm._v("Income:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.Income || 0))])]), _vm._v(" "), _c('div', {
          staticClass: "d-flex justify-content-between font-weight-bold",
          class: data.item.Profit >= 0 ? 'text-primary' : 'text-danger'
        }, [_c('span', [_vm._v("Profit:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.Profit || 0))])])]) : _vm._e()]
      }
    }, {
      key: "subDetails",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column small"
        }, [_c('div', [_c('strong', [_vm._v("Push To Accounts Date:")]), _vm._v(" " + _vm._s(data.item.PushToAccountsDate || 'N/A'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("VGM:")]), _vm._v(" " + _vm._s(data.item.VgmSubmissionDateActual || 'N/A'))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted mb-1"
        }, [_vm._v("Due: " + _vm._s(data.item.VgmDueDate || 'N/A'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("SI:")]), _vm._v(" " + _vm._s(data.item.SiSubmissiondateActual || 'N/A'))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted mb-1"
        }, [_vm._v("Due: " + _vm._s(data.item.SiDueDate || 'N/A'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("TR:")]), _vm._v(" " + _vm._s(data.item.TrSubmissiondateActual || 'N/A'))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted mb-1"
        }, [_vm._v("Due: " + _vm._s(data.item.TrDueDate || 'N/A'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("H/O:")]), _vm._v(" " + _vm._s(data.item.HandoverDateActual || 'N/A'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("GateIn Due:")]), _vm._v(" " + _vm._s(data.item.GateInDueDate || 'N/A'))])]) : _vm._e()]
      }
    }, {
      key: "blDetails",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column small"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("MBL: " + _vm._s(data.item.MblNo || 'N/A'))]), _vm._v(" "), _c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("MBL Date: " + _vm._s(data.item.MblDate || 'N/A'))]), _vm._v(" "), _c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("MBL Release Date: " + _vm._s(data.item.MblReleaseDate || 'N/A'))]), _vm._v(" "), _c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("First HBL Date: " + _vm._s(data.item.FirstHblDate || 'N/A'))]), _vm._v(" "), _c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Linear BL Upload Date: " + _vm._s(data.item.LinearBlUploadDate || 'N/A'))]), _vm._v(" "), _c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("HBL: " + _vm._s(data.item.HblNo || 'N/A'))]), _vm._v(" "), _c('div', {
          staticClass: "mt-1 text-muted"
        }, [_vm._v("Type: " + _vm._s(data.item.blType || 'N/A'))]), _vm._v(" "), _c('div', {
          staticClass: "d-flex gap-1 mt-1"
        }, [_c('span', {
          staticClass: "badge badge-light"
        }, [_vm._v("M:" + _vm._s(data.item.frghtTermsMbl || 'N/A'))]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-light"
        }, [_vm._v("H:" + _vm._s(data.item.frghtTermsHbl || 'N/A'))])])]) : _vm._e()]
      }
    }, {
      key: "contDetails",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column small"
        }, [_c('div', {
          staticClass: "text-wrap font-weight-bold"
        }, [_vm._v(_vm._s(data.item.FreightContainers || 'N/A'))]), _vm._v(" "), _c('div', {
          staticClass: "mt-1"
        }, [_vm._v(_vm._s(data.item.FreightContainersType) + " (" + _vm._s(data.item.MultipleContainerNo) + ")")]), _vm._v(" "), _c('div', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.StuffingType) + " | " + _vm._s(data.item.FclLcl))]), _vm._v(" "), _c('hr', {
          staticClass: "my-1"
        }), _vm._v(" "), _c('div', [_c('strong', [_vm._v("S.Inv:")]), _vm._v(" " + _vm._s(data.item.SINVNO || 'N/A'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("S.Bill:")]), _vm._v(" " + _vm._s(data.item.SBILLNO || 'N/A'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Seals (C/L):")])]), _vm._v(" "), _c('div', {
          staticClass: "text-wrap"
        }, [_vm._v(_vm._s(data.item.CUST_SEAL_NO || 'N/A') + " / " + _vm._s(data.item.LINE_SEAL_NO || 'N/A'))])]) : _vm._e()]
      }
    }, {
      key: "dates",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column small"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("SOB Dates:")]), _vm._v(" "), _c('div', {
          staticClass: "ml-1"
        }, [_vm._v("Sys SOB: " + _vm._s(data.item.SysSOB || 'N/A'))]), _vm._v(" "), _c('div', {
          staticClass: "ml-1 text-primary"
        }, [_vm._v("SOB: " + _vm._s(data.item.SOB || 'N/A'))]), _vm._v(" "), _c('hr', {
          staticClass: "my-1"
        }), _vm._v(" "), _c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v("MBL Rel:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.MblDate || 'N/A'))])])]) : _vm._e()]
      }
    }, {
      key: "status",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column gap-1 small"
        }, [_c('div', {
          staticClass: "badge badge-primary mb-1 text-wrap"
        }, [_vm._v(_vm._s(data.item.status_verbose))]), _vm._v(" "), _c('div', {
          staticClass: "d-flex flex-wrap gap-1"
        }, [_c('span', {
          staticClass: "badge badge-info"
        }, [_vm._v("BL: " + _vm._s(data.item.BlReleaseStatus))]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-warning"
        }, [_vm._v("Sline Pay: " + _vm._s(data.item.SlinePaymentStatus))]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v("Prealert: " + _vm._s(data.item.PrealertStatus))]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-dark"
        }, [_vm._v("FF Inv: " + _vm._s(data.item.FFInvStatus))]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-dark"
        }, [_vm._v("CC Inv: " + _vm._s(data.item.CCInvStatus))]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-dark"
        }, [_vm._v("TPT Inv: " + _vm._s(data.item.TPTInvStatus))]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-light border"
        }, [_vm._v("Line Inv: " + _vm._s(data.item.LineInvStatus))]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-light border"
        }, [_vm._v("Inv Side: " + _vm._s(data.item.InvoiceSideStatus))]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-light border"
        }, [_vm._v("Tb Side: " + _vm._s(data.item.TallyBillingSideStatus))])]), _vm._v(" "), _c('div', {
          staticClass: "d-flex flex-wrap gap-1 mt-1"
        }, [(data.item.IsRollover !== 'Not RollOvers') ? _c('span', {
          staticClass: "badge badge-danger"
        }, [_vm._v("Rollover: " + _vm._s(data.item.IsRollover))]) : _vm._e(), _vm._v(" "), (data.item.IsManifestation === 'Yes') ? _c('span', {
          staticClass: "badge badge-success"
        }, [_vm._v("Manifest: Yes")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "badge badge-info"
        }, [_vm._v("Billing: " + _vm._s(data.item.BillingStatus))]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v("Type: " + _vm._s(data.item.IsBillingTypeStatus))])]), _vm._v(" "), _c('div', {
          staticClass: "mt-1 font-weight-bold"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Terms:")]), _vm._v(" " + _vm._s(data.item.DeliveryTerms || 'N/A') + " | " + _vm._s(data.item.DeliveryMode || 'N/A') + "\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "mt-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Overseas:")]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-info"
        }, [_vm._v(_vm._s(data.item.closedOverseasStatus))])]), _vm._v(" "), (data.item.JobDeleteStatus !== 'Not Deleted') ? _c('div', {
          staticClass: "small text-danger font-weight-bold"
        }, [_vm._v("\n                " + _vm._s(data.item.JobDeleteStatus) + "\n              ")]) : _vm._e()]) : _vm._e()]
      }
    }, {
      key: "TallyInvoiceNo",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column small",
          style: (data.item.TallyPendingHighlight ? 'background-color: #fff3cd; padding: 2px; border-radius: 4px;' : '')
        }, [_c('div', {
          staticClass: "font-weight-bold text-success"
        }, [_vm._v("Inv: " + _vm._s(data.item.TallyInvoiceNo || 'N/A'))]), _vm._v(" "), (data.item.TallyPendingHighlight) ? _c('div', {
          staticClass: "text-danger font-weight-bold small"
        }, [_vm._v("PENDING FROM TALLY")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("Date: " + _vm._s(data.item.TallyInvoiceDate || 'N/A'))]), _vm._v(" "), (data.item.RInvNo !== 'N/A') ? _c('div', {
          staticClass: "mt-1"
        }, [_c('div', {
          staticClass: "text-muted"
        }, [_vm._v("Rev: " + _vm._s(data.item.RInvNo))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted"
        }, [_vm._v("RevDate: " + _vm._s(data.item.ReverseTallyInvDate))])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "mt-1 text-info font-weight-bold"
        }, [_vm._v("\n                " + _vm._s(data.item.TallyBillingClosedStatus) + "\n              ")]), _vm._v(" "), (data.item.ExecutionInvoices) ? _c('div', {
          staticClass: "mt-1 small"
        }, [_c('strong', [_vm._v("Ex.Inv:")]), _vm._v(" " + _vm._s(_vm.truncateText(data.item.ExecutionInvoices, 30)) + "\n              ")]) : _vm._e()]) : _vm._e()]
      }
    }, {
      key: "HighAlert",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "text-center"
        }, [(data.item.HighAlert) ? _c('b-badge', {
          staticClass: "p-2",
          attrs: {
            "variant": "danger"
          }
        }, [_c('i', {
          staticClass: "fa fa-exclamation-triangle mr-1"
        }), _vm._v(" HIGH ALERT\n                "), _c('div', {
          staticClass: "mt-1 small"
        }, [_vm._v(_vm._s(data.item.HighAlertDays) + " Days from SOB")])]) : _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Normal")])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "id": "doc",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-pagination', {
    attrs: {
      "limit": "10",
      "align": "center",
      "per-page": _vm.pageSize,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f786c3e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/reports/ffExportBillingReport.vue
// module id = 2785
// module chunks = 0